export default {
  common: {
    nav: {
      home: "الرئيسية",
      find_offer_help: "ابحث عن / قدّم مساعدة",
      celebrate: "احتفل بحياة",
      family_tree: "شجرة العائلة",
      events: "الفعاليات",
      civic_reports: "تقارير مدنية",
      neighborhood_pulse: "نبض الحي",
      weather: "الطقس",
      nature: "الطبيعة",
      marketplace: "السوق",
      news: "الأخبار",
      causes: "القضايا",
      more: "المزيد",
    },
    header: { sign_in: "تسجيل الدخول", join: "انضم إلى Social Pulse", language: "اللغة", search: "بحث" },
    tagline: "ربط المجتمعات · تمكين الحياة · بناء رأس المال الاجتماعي",
    locality: {
      viewing_from: "أنت تشاهد من",
      help_improve: "ساعدنا في تحسين موقعك",
      filter_by_country: "التصفية حسب البلد",
      change: "تغيير",
      set_your_location: "حدد موقعك",
      set_your_location_hint: "— اضغط للتخصيص",
    },
    actions: {
      submit_cause: "قدّم قضية / نداء",
      make_donation: "ادعم مبادرات Social Pulse العالمية — تبرّع الآن",
      browse_all: "تصفح جميع الأقسام",
    },
    news: {
      title: "موجزك اليومي.",
      submit_news: "إرسال خبر",
      archive: "الأرشيف",
      weather_nature: "الطقس والطبيعة",
      play_briefing: "تشغيل الموجز اليومي",
      play_briefing_hint: "استمع إلى أهم {{count}} أخبار · ~{{minutes}} دقيقة · بلغتك",
      read_original: "اقرأ الأصلي",
      view_brief: "عرض الملخص",
      also_reported_by: "أيضاً نشرها:",
      translate: "ترجم",
      listen: "استمع",
      stop: "إيقاف",
    },
  },
};
